// @ts-nocheck
import { Component } from 'react';
import { ApplyPluginsType } from 'umi';
import dva from 'dva';
// @ts-ignore
import createLoading from 'C:/code/freelogfe/freelogfe-web-repos/packages/console/node_modules/.pnpm/dva-loading@3.0.25_dva-core@1.6.0-beta.7/node_modules/dva-loading/dist/index.esm.js';
import { plugin, history } from '../core/umiExports';
import ModelTemplate0 from 'C:/code/freelogfe/freelogfe-web-repos/packages/console/src/models/__template.ts';
import ModelCollectionCreatorPage1 from 'C:/code/freelogfe/freelogfe-web-repos/packages/console/src/models/collectionCreatorPage.ts';
import ModelCollectionDetailPage2 from 'C:/code/freelogfe/freelogfe-web-repos/packages/console/src/models/collectionDetailPage.ts';
import ModelCollectionExhibitInfoPage3 from 'C:/code/freelogfe/freelogfe-web-repos/packages/console/src/models/collectionExhibitInfoPage.ts';
import ModelCollectionListPage4 from 'C:/code/freelogfe/freelogfe-web-repos/packages/console/src/models/collectionListPage.ts';
import ModelCollectionManager5 from 'C:/code/freelogfe/freelogfe-web-repos/packages/console/src/models/collectionManager.ts';
import ModelCreatedCollectionExhibitInfoPage6 from 'C:/code/freelogfe/freelogfe-web-repos/packages/console/src/models/createdCollectionExhibitInfoPage.ts';
import ModelDashboardPage7 from 'C:/code/freelogfe/freelogfe-web-repos/packages/console/src/models/dashboardPage.ts';
import ModelDiscoverPage8 from 'C:/code/freelogfe/freelogfe-web-repos/packages/console/src/models/discoverPage.ts';
import ModelExhibitInfoPage9 from 'C:/code/freelogfe/freelogfe-web-repos/packages/console/src/models/exhibitInfoPage.ts';
import ModelGlobal10 from 'C:/code/freelogfe/freelogfe-web-repos/packages/console/src/models/global.ts';
import ModelGlobalSearching11 from 'C:/code/freelogfe/freelogfe-web-repos/packages/console/src/models/globalSearching.ts';
import ModelInformalNodeManagerPage12 from 'C:/code/freelogfe/freelogfe-web-repos/packages/console/src/models/informalNodeManagerPage.ts';
import ModelInformExhibitInfoPage13 from 'C:/code/freelogfe/freelogfe-web-repos/packages/console/src/models/informExhibitInfoPage.ts';
import ModelNodeCreatorPage14 from 'C:/code/freelogfe/freelogfe-web-repos/packages/console/src/models/nodeCreatorPage.ts';
import ModelNodeManagerContractPage15 from 'C:/code/freelogfe/freelogfe-web-repos/packages/console/src/models/nodeManager_Contract_Page.ts';
import ModelNodeManagerPage16 from 'C:/code/freelogfe/freelogfe-web-repos/packages/console/src/models/nodeManagerPage.ts';
import ModelNodes17 from 'C:/code/freelogfe/freelogfe-web-repos/packages/console/src/models/nodes.ts';
import ModelResourceAuthPage18 from 'C:/code/freelogfe/freelogfe-web-repos/packages/console/src/models/resourceAuthPage.ts';
import ModelResourceCollectPage19 from 'C:/code/freelogfe/freelogfe-web-repos/packages/console/src/models/resourceCollectPage.ts';
import ModelResourceCreatorBatchPage20 from 'C:/code/freelogfe/freelogfe-web-repos/packages/console/src/models/resourceCreatorBatchPage.ts';
import ModelResourceCreatorPage21 from 'C:/code/freelogfe/freelogfe-web-repos/packages/console/src/models/resourceCreatorPage.ts';
import ModelResourceDependencyPage22 from 'C:/code/freelogfe/freelogfe-web-repos/packages/console/src/models/resourceDependencyPage.ts';
import ModelResourceDetailPage23 from 'C:/code/freelogfe/freelogfe-web-repos/packages/console/src/models/resourceDetailPage.ts';
import ModelResourceEditorPage24 from 'C:/code/freelogfe/freelogfe-web-repos/packages/console/src/models/resourceEditorPage.ts';
import ModelResourceInfoPage25 from 'C:/code/freelogfe/freelogfe-web-repos/packages/console/src/models/resourceInfoPage.ts';
import ModelResourceListPage26 from 'C:/code/freelogfe/freelogfe-web-repos/packages/console/src/models/resourceListPage.ts';
import ModelResourceSider27 from 'C:/code/freelogfe/freelogfe-web-repos/packages/console/src/models/resourceSider.ts';
import ModelResourceVersionCreatorPage28 from 'C:/code/freelogfe/freelogfe-web-repos/packages/console/src/models/resourceVersionCreatorPage.ts';
import ModelResourceVersionEditorPage29 from 'C:/code/freelogfe/freelogfe-web-repos/packages/console/src/models/resourceVersionEditorPage.ts';
import ModelStorageHomePage30 from 'C:/code/freelogfe/freelogfe-web-repos/packages/console/src/models/storageHomePage.ts';
import ModelStorageObjectEditor31 from 'C:/code/freelogfe/freelogfe-web-repos/packages/console/src/models/storageObjectEditor.ts';
import ModelUser32 from 'C:/code/freelogfe/freelogfe-web-repos/packages/console/src/models/user.ts';

let app:any = null;

export function _onCreate(options = {}) {
  const runtimeDva = plugin.applyPlugins({
    key: 'dva',
    type: ApplyPluginsType.modify,
    initialValue: {},
  });
  app = dva({
    history,
    
    ...(runtimeDva.config || {}),
    // @ts-ignore
    ...(typeof window !== 'undefined' && window.g_useSSR ? { initialState: window.g_initialProps } : {}),
    ...(options || {}),
  });
  
  app.use(createLoading());
  (runtimeDva.plugins || []).forEach((plugin:any) => {
    app.use(plugin);
  });
  app.model({ namespace: '__template', ...ModelTemplate0 });
app.model({ namespace: 'collectionCreatorPage', ...ModelCollectionCreatorPage1 });
app.model({ namespace: 'collectionDetailPage', ...ModelCollectionDetailPage2 });
app.model({ namespace: 'collectionExhibitInfoPage', ...ModelCollectionExhibitInfoPage3 });
app.model({ namespace: 'collectionListPage', ...ModelCollectionListPage4 });
app.model({ namespace: 'collectionManager', ...ModelCollectionManager5 });
app.model({ namespace: 'createdCollectionExhibitInfoPage', ...ModelCreatedCollectionExhibitInfoPage6 });
app.model({ namespace: 'dashboardPage', ...ModelDashboardPage7 });
app.model({ namespace: 'discoverPage', ...ModelDiscoverPage8 });
app.model({ namespace: 'exhibitInfoPage', ...ModelExhibitInfoPage9 });
app.model({ namespace: 'global', ...ModelGlobal10 });
app.model({ namespace: 'globalSearching', ...ModelGlobalSearching11 });
app.model({ namespace: 'informalNodeManagerPage', ...ModelInformalNodeManagerPage12 });
app.model({ namespace: 'informExhibitInfoPage', ...ModelInformExhibitInfoPage13 });
app.model({ namespace: 'nodeCreatorPage', ...ModelNodeCreatorPage14 });
app.model({ namespace: 'nodeManager_Contract_Page', ...ModelNodeManagerContractPage15 });
app.model({ namespace: 'nodeManagerPage', ...ModelNodeManagerPage16 });
app.model({ namespace: 'nodes', ...ModelNodes17 });
app.model({ namespace: 'resourceAuthPage', ...ModelResourceAuthPage18 });
app.model({ namespace: 'resourceCollectPage', ...ModelResourceCollectPage19 });
app.model({ namespace: 'resourceCreatorBatchPage', ...ModelResourceCreatorBatchPage20 });
app.model({ namespace: 'resourceCreatorPage', ...ModelResourceCreatorPage21 });
app.model({ namespace: 'resourceDependencyPage', ...ModelResourceDependencyPage22 });
app.model({ namespace: 'resourceDetailPage', ...ModelResourceDetailPage23 });
app.model({ namespace: 'resourceEditorPage', ...ModelResourceEditorPage24 });
app.model({ namespace: 'resourceInfoPage', ...ModelResourceInfoPage25 });
app.model({ namespace: 'resourceListPage', ...ModelResourceListPage26 });
app.model({ namespace: 'resourceSider', ...ModelResourceSider27 });
app.model({ namespace: 'resourceVersionCreatorPage', ...ModelResourceVersionCreatorPage28 });
app.model({ namespace: 'resourceVersionEditorPage', ...ModelResourceVersionEditorPage29 });
app.model({ namespace: 'storageHomePage', ...ModelStorageHomePage30 });
app.model({ namespace: 'storageObjectEditor', ...ModelStorageObjectEditor31 });
app.model({ namespace: 'user', ...ModelUser32 });
  return app;
}

export function getApp() {
  return app;
}

/**
 * whether browser env
 * 
 * @returns boolean
 */
function isBrowser(): boolean {
  return typeof window !== 'undefined' &&
  typeof window.document !== 'undefined' &&
  typeof window.document.createElement !== 'undefined'
}

export class _DvaContainer extends Component {
  constructor(props: any) {
    super(props);
    // run only in client, avoid override server _onCreate()
    if (isBrowser()) {
      _onCreate()
    }
  }

  componentWillUnmount() {
    let app = getApp();
    app._models.forEach((model:any) => {
      app.unmodel(model.namespace);
    });
    app._models = [];
    try {
      // 释放 app，for gc
      // immer 场景 app 是 read-only 的，这里 try catch 一下
      app = null;
    } catch(e) {
      console.error(e);
    }
  }

  render() {
    let app = getApp();
    app.router(() => this.props.children);
    return app.start()();
  }
}
